/**
 * @typedef {Object} ProxyServer
 * @property {string} id - The unique identifier of the proxy server.
 * @property {string} name - The name of the proxy server.
 * @property {string} url - The URL of the proxy server.
 */

/**
 * @typedef {Object} Fingerprint
 * @property {string} id - The unique identifier of the client fingerprint.
 * @property {string} userAgent - The user agent string of the client fingerprint.
 * @property {string} name - The name of the client fingerprint.
 */

/**
 * @typedef {Object} MainPageData
 * @property {Array<string>} popularUrls - List of popular urls.
 * @property {Array<ProxyServer>} proxyServers - List of proxy servers.
 * @property {Array<Fingerprint>} fingerprints - List of client fingerprints.
 */

/**
 * @typedef {Object} MainPageState
 * @property {MainPageData|null} mainPageData - The data related to the main page.
 * @property {boolean} isLoading - Indicates if the content is currently being loaded.
 * @property {string} isError - Holds any error message if fetching content fails.
 */

/**
 * Selects the main page state from the Redux store.
 * @param {Object} state - The current state of the Redux store.
 * @returns {MainPageState} The main page state.
 */
import { useSelector } from "react-redux";

export const useMainPageState = () => {
  const { mainPageData, isDataLoaded, isLoading, isError } = useSelector(
    state => state.mainPage,
  );

  return {
    mainPageData,
    isDataLoaded,
    isLoading,
    isError,
  };
};
